import { getCookieValue } from './common';
import { WEBAPP_WEBSITE_DOMAIN } from './constants';
export var supportedLanguages = ['en', 'es', 'ja', 'tr', 'fr', 'de', 'it', 'pt', 'nl', 'pl'];
export function getInitialLanguage() {
    // RDP domain → always EN
    if (window.location.hostname.includes('remotedesktop.com')) {
        console.log('[i18n] RDP domain detected:', window.location.hostname, '→ forcing EN');
        return 'en';
    }
    // Check cookie first
    var cookieLang = getCookieValue('lang');
    if (cookieLang) {
        return cookieLang;
    }
    // Check browser language
    var browserLang = (navigator.language || 'en').split('-')[0].toLowerCase();
    // Fix: use includes() not filter()
    if (supportedLanguages.indexOf(browserLang) !== -1) {
        return browserLang;
    }
    // Fallback to English
    return 'en';
}
export function getLocalizedURL() {
    var langCode = getInitialLanguage();
    if (langCode === 'en')
        return "".concat(WEBAPP_WEBSITE_DOMAIN, "/index.html");
    else {
        return "".concat(WEBAPP_WEBSITE_DOMAIN, "/").concat(langCode, "/index.html");
    }
}
